<template>

  <div class="oauth_container">

    <span>You have been disconnected from your previous signin provider.</span>
    <br><br>
    <span>Please try again by clicking the link below</span>
    <br><br>
    <router-link to="/login" class="button" replace>Log in again</router-link>
    <p>
    </p>

  </div>
    

</template>

<script>

// import { authService } from '../services/auth';

export default {
  name: 'OauthSignout',
  mounted() {
    this.$router.replace("/preg")
  }
}
</script>



<style lang="scss" scoped>
.oauth_container {
  margin-top: 6rem;
  min-height: 50vh;
}
</style>